import React, { memo } from 'react';
import { durationLabel, sentenceCase } from './agendaDay';

const HOUR = 60 * 60000;

// Separador visível que o leitor de tela troca por uma palavra (", com", ", status")
const Separator = ({ visible = ' · ', spoken = ', ' }) => (
  <><span aria-hidden='true'>{visible}</span><span className='visually-hidden'>{spoken}</span></>
);

// Cartão da Lista do dia: um <li> com um único botão, que abre o "Detalhes do agendamento".
// O nome acessível é o próprio texto, na ordem do DOM e com palavras ocultas que dão sentido:
// "08:00 até 08:15, ANA SOUZA, Avaliação, com BRUNO, Atendimentos: 3/10, status REALIZADO".
// O status vem por último no DOM e vai para o canto de cima pela grade do CSS
const AppointmentCard = ({ item, kind, doctorName, onOpen }) => {
  const color = item.status?.cor || '#adb5bd';
  const duration = item.end - item.start >= HOUR ? durationLabel(item.start, item.end) : '';
  const progress = kind !== 'block' ? item.prontuario?.progresso : '';

  return (
    <li className={`agenda-day-card is-${kind}`} style={{ '--agenda-status': color }} data-id={item.id}>
      <button type='button' className='agenda-day-card-button' onClick={() => onOpen(item)}>
        <span className='agenda-day-time'>
          {item.hora_inicial}<Separator visible='–' spoken=' até ' />{item.hora_final}
          {duration ? <span className='agenda-day-duration'><span className='visually-hidden'>, </span>{duration}</span> : ''}
        </span>
        <span className='agenda-day-patient'>
          <span className='visually-hidden'>, </span>{kind === 'block' ? 'Horário bloqueado' : item.paciente?.nome}
        </span>
        <span className='agenda-day-detail'>
          <span className='visually-hidden'>, </span>{kind === 'block' ? 'Bloqueio' : sentenceCase(item.tipo_atendimento?.descricao)}
          <Separator spoken=', com ' />{doctorName}
          {progress ? <><Separator />Atendimentos: {progress}</> : ''}
          {kind === 'released' ? <><Separator />horário liberado</> : ''}
        </span>
        <span className='agenda-day-status'>
          <span className='visually-hidden'>, status </span>
          <span className='agenda-day-bullet' aria-hidden='true' style={{ backgroundColor: color }} />
          {/* Maiúsculas só no nome: o Chrome passa o text-transform para o texto oculto ("STATUS") */}
          <span className='agenda-day-status-name'>{item.status?.nome ?? 'Sem status'}</span>
        </span>
      </button>
    </li>
  );
};

// memo + key = id na lista: a atualização de 30 s não recria os botões, e a rolagem e o foco ficam onde estavam
export default memo(AppointmentCard);
